import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BoltOffIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M3.116 4.116c.337-.397.938-.35 1.5.115L21.509 18.22c.563.466.714 1.041.376 1.438-.337.397-.938.351-1.5-.115l-4.062-3.364-4.019 6.915c-.977 1.68-3.694.835-3.46-.995l.023-.136 1.498-7.393H8.848c-1.301 0-2.163-1.202-1.739-2.29l.053-.12.06-.115 1.332-2.299-5.062-4.192c-.523-.433-.69-.96-.44-1.35zm6.855 6.803l-.253.436a1 1 0 00-.126.37l-.009.132a1 1 0 00.884.993l.116.007h.783a1 1 0 01.997 1.083l-.017.115-1.426 7.035a.2.2 0 00.329.19l.04-.05 3.617-6.224-4.935-4.087zm7.169-9.03l-.022.138-1.453 7.403h1.487c1.302 0 2.164 1.204 1.738 2.292l-.053.12-.061.115-.53.911-4.415-3.651 1.241-6.324a.2.2 0 00-.056-.181l-.04-.03a.2.2 0 00-.232.023l-.04.05-2.816 4.856-1.417-1.172L13.678.908c.971-1.677 3.68-.844 3.462.98z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
BoltOffIcon.isCarinaIcon = true;
export default BoltOffIcon;
